import React, { useState } from 'react';
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@mui/material';

interface Props {
  accountName: string;
  onDelete: () => void;
}

export const AccountDangerZone: React.FC<Props> = ({ accountName, onDelete }) => {
  const [open, setOpen] = useState(false);

  const handleOpenDialog = () => setOpen(true);
  const handleCloseDialog = () => setOpen(false);

  const handleConfirmDelete = () => {
    setOpen(false);
    onDelete();
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Alert severity="error" variant="outlined" sx={{ alignItems: 'flex-start' }}>
        <AlertTitle>Danger Zone</AlertTitle>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Permanently delete this account and all associated data. This action cannot be undone.
        </Typography>
        <Button variant="outlined" color="error" size="small" onClick={handleOpenDialog}>
          Delete permanently
        </Button>
      </Alert>

      <Dialog open={open} onClose={handleCloseDialog} aria-labelledby="danger-zone-dialog-title">
        <DialogTitle id="danger-zone-dialog-title">Permanently delete account?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            You are about to permanently delete <strong>{accountName}</strong> and all associated
            data. This action cannot be undone and there is no recovery option.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleConfirmDelete} color="error" variant="contained">
            Delete permanently
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
